/* cf-mobile-polish.js - Click Fencing calculators on a phone: less button, more fence.
 *
 * Pete 2026-09-11, on the combined preview on his Samsung: "It does the same thing with
 * the buttons for the calc. Can they take up less of the screen? The fence drawing also
 * looks terrible."
 *
 * Measured on an emulated 375x812 phone, 6580mm section, theme 141671006302:
 *
 * 1. THE BUTTON ROW. cf-calc-mobile-keyboard.js made .section-tabs wrap so a long row of
 *    section tabs + Delete could not run off the right edge. It also stretched the inline
 *    Next to full width, so the row became 3 rows: glass 148px, blade 183px, where live
 *    used 63px. Now ONE slim row (36px buttons) that scrolls sideways when there are many
 *    sections - nothing is cut off and nothing is out of reach, which was the original
 *    point of the wrap. Next goes last, on the right. Both Nexts stay: the bottom bar's
 *    Next drives the step buttons (#nav-next etc), the inline one also moves between
 *    sections.
 *
 * 2. THE GLASS DRAWING. Pete 2026-08-29 asked for glass to "stay large like the aluminium
 *    fences", so cf-preview-scroll pins glass to a floor scale and lets it scroll - and
 *    that rule stands. But it widened each panel's SLOT (119px for a 1650mm panel) without
 *    growing the glass artwork inside it, which the calculator still drew at its own
 *    shrunken scale (65px). Every pane sat in the middle of a slot almost twice its width:
 *    tiny panes, big empty gaps, and still a sideways scroll. Each pane now fills its slot,
 *    keeping its real height:width ratio (the spigots are placed in % so they follow).
 *    Glass only - the aluminium drawings are SVG and already fill their space.
 *    The gap badges were drawn at 8px and turned on their side; now level, 10px.
 *
 * 3. THE FLOATERS. The "Send us your plans" pill (.cf-plans) and the quick-price bubble
 *    (#qpw-bubble) sat on top of the form fields. While a field is focused - keyboard up,
 *    ~360px of screen left - they step aside. Reuses cf-calc-mobile-keyboard.js's own
 *    body.cf-cmk-typing flag rather than tracking focus a second way.
 *
 * MOBILE ONLY (<=749px, the same breakpoint as the keyboard script). Display only -
 * touches no price, product, quantity or cart line. Loads after cf-calc-mobile-keyboard.js
 * so its row rules win; selectors carry an extra [class] to be sure of it.
 */
(function () {
  if (window.__cfMobilePolish) return;
  window.__cfMobilePolish = true;
  var BP = 749;

  try {
    var s = document.createElement('style');
    s.id = 'cf-mp-css';
    s.textContent = [
      '@media (max-width: 749px){',
      /* 1. one slim, swipeable button row */
      '  body .calculator-page .section-tabs[class] > div{display:flex!important;flex-wrap:nowrap!important;',
      '    overflow-x:auto!important;overflow-y:hidden!important;gap:6px!important;align-items:center!important;',
      '    padding:2px 0 6px!important;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
      '  body .calculator-page .section-tabs[class] > div::-webkit-scrollbar{display:none}',
      '  body .calculator-page .section-tabs[class] > div > *{flex:0 0 auto!important;width:auto!important;margin:0!important}',
      '  body .calculator-page .section-tabs[class] button[class]{height:36px!important;min-height:0!important;',
      /* 10px sides, not 12: at 12 "Section 1 + Add section + Next" needed 4px more than the
         blade row's 286px, and the pinned Next overlapped Add section by exactly that. */
      '    padding:0 10px!important;font-size:14px!important;line-height:1!important;width:auto!important;',
      '    border-radius:8px!important;box-shadow:none!important;white-space:nowrap!important}',
      /* Next is last and PINNED to the right edge of the row (sticky inside the row's own
         horizontal scroller), so with 3+ sections the tabs slide under it and Next never
         scrolls out of reach - Pete's "next button hard to find" from 2026-09-10. */
      '  body .calculator-page .section-tabs[class] > div > button.btn-primary{order:99!important;margin-left:auto!important;',
      '    position:sticky!important;right:0!important;z-index:2!important}',
      /* 2b. glass gap badges level and legible */
      '  body .calculator-page #section-preview .gap-width[style]{writing-mode:horizontal-tb!important;',
      '    transform:none!important;font-size:10px!important;padding:1px 2px!important}',
      /* 3. floaters step aside while typing */
      '  body.cf-cmk-typing .cf-plans, body.cf-cmk-typing #qpw-bubble{opacity:0!important;',
      '    pointer-events:none!important;transform:translateY(140%)!important;transition:opacity .15s,transform .15s!important}',
      '}'
    ].join('');
    document.head.appendChild(s);
  } catch (e) { /* a display fix must never break the calculator */ }

  /* 2. glass panes fill their slots. Idempotent: a pane already within 1px of its slot is
     left alone, so the style writes below cannot feed the observer forever. */
  function grow() {
    try {
      if (window.innerWidth > BP) return;
      var p = document.getElementById('section-preview');
      if (!p || p.querySelector('svg')) return;           // aluminium draws in SVG
      var slots = p.querySelectorAll('.panels-container > div:not(.gap-preview)');
      for (var i = 0; i < slots.length; i++) {
        var w = slots[i];
        var pp = w.querySelector('.panel-preview');
        var box = pp && pp.firstElementChild;
        if (!box) continue;
        var slot = w.getBoundingClientRect().width;
        var cur = box.getBoundingClientRect().width;
        var target = Math.max(20, slot - 6);
        if (!cur || Math.abs(cur - target) < 1) continue;
        var k = target / cur;
        var glass = box.firstElementChild;
        var gh = glass ? parseFloat(glass.style.height) || 0 : 0;
        var bh = parseFloat(box.style.height) || box.getBoundingClientRect().height;
        pp.style.setProperty('width', target + 'px', 'important');
        box.style.setProperty('width', target + 'px', 'important');
        box.style.setProperty('height', (bh - gh + gh * k) + 'px', 'important');
        if (glass && gh) glass.style.setProperty('height', (gh * k) + 'px', 'important');
      }
    } catch (e) { /* never break the calculator */ }
  }

  var t1, t2, watched = null;
  function schedule() {
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(grow, 40);
    t2 = setTimeout(grow, 400);                            // after cf-preview-scroll resizes slots
  }
  function watch() {
    var p = document.getElementById('section-preview');
    if (!p || p === watched) return;
    watched = p;
    new MutationObserver(schedule).observe(p, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    schedule();
  }
  var tries = 0;
  (function poll() { watch(); if (++tries < 120) setTimeout(poll, 500); })();
  window.addEventListener('resize', schedule);
  try { console.log('[cf-mobile-polish] installed'); } catch (e) {}
})();
